// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1726ce45","646":"7d9f08a4","890":"fb283745","894":"c6ccc869","956":"6e8eed7e","981":"5c2948e1"}[chunkId] + ".chunk.js";
};